import { NullableFormValue, ValueConverter } from "../index";
import { ArabicChars, filterCharSet } from "@my-dld/components/TextFilters/RegExFilter";


class NoArabicConverter implements ValueConverter<string, string> {
	toData( inp: NullableFormValue<string, number> ): NullableFormValue<string, string> {
		if ( inp != null ) {
			return filterCharSet( inp + "", false, ArabicChars );
		}
		return inp;
	}

	fromData( inp: NullableFormValue<string, string> ): NullableFormValue<string, string> {
		if ( inp != null ) {
			return filterCharSet( inp + "", false, ArabicChars );
		}
		return inp;
	}
}

const noArabicConverter = new NoArabicConverter();
export default noArabicConverter;
